
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Contact(props) {
    return (
        <SvgIcon {...props}>
            <path d="M29.7 18.8c-1.1 5.5-5.5 9.9-11.1 10.9-.4.7-1.2 1.3-2.2 1.3-1.4 0-2.5-1.1-2.5-2.5S15 26 16.4 26c1.1 0 2 .7 2.3 1.6 4.5-1.1 8-4.7 8.9-9.3-.3-.5-.6-1.3-.6-2.3s.3-1.8.8-2.3C26.7 8.2 21.8 4 16 4 10.2 4 5.3 8.2 4.2 13.7c.5.5.8 1.3.8 2.3 0 1.7-.9 3-2 3s-2-1.3-2-3c0-1.3.5-2.4 1.3-2.8C3.6 6.8 9.2 2 16 2s12.4 4.8 13.7 11.2c.7.4 1.3 1.5 1.3 2.8s-.5 2.4-1.3 2.8zM13 13.5c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5.7 1.5 1.5 1.5 1.5-.7 1.5-1.5zm7.5 1.5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5-1.5.7-1.5 1.5.7 1.5 1.5 1.5zm-.7 5.7c1-.7 1.6-1.7 1.6-2.7v-.2h-1.9v.2c0 .4-.4.9-1 1.2-.6.4-1.5.6-2.4.6-.9 0-1.7-.2-2.4-.6-.6-.3-1-.8-1-1.2v-.2h-1.9v.2c0 1 .6 2 1.6 2.7 1 .7 2.3 1.1 3.7 1.1s2.7-.4 3.7-1.1z" />
        </SvgIcon>
    );
}

Contact.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Contact;
